import { useQuery } from "@tanstack/react-query";
import { getAtkomstStores } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { fixaTeamVirtualStores, Store } from "../../shared/types/store";

const getAtkomstStoresWithVirtualStores = async (
  hasPlatformOwnerAuthorization: boolean
) => {
  const atkomstFilteredStores = await getAtkomstStores();

  if (!hasPlatformOwnerAuthorization) {
    return atkomstFilteredStores;
  }

  const virtualStores = fixaTeamVirtualStores
    .map(({ baseStoreId, suffix }) => {
      const baseStore = atkomstFilteredStores.find(
        (store: Store) => store.storeId === baseStoreId
      );
      return baseStore
        ? { ...baseStore, storeId: `${baseStoreId}${suffix}` }
        : undefined;
    })
    .filter((store): store is Store => !!store);

  return [...virtualStores, ...atkomstFilteredStores];
};

export const useAtkomstCoreStores = (
  hasPlatformOwnerAuthorization: boolean,
  enabled = true
) =>
  useQuery<Store[]>({
    queryKey: ["atkomstStores", hasPlatformOwnerAuthorization],
    queryFn: () =>
      getAtkomstStoresWithVirtualStores(hasPlatformOwnerAuthorization),
    enabled,
    staleTime: 15 * INTERVAL.MINUTE,
    gcTime: 15 * INTERVAL.MINUTE,
  });
